import * as React from 'react';
import type { WithTabbingTrapProps } from './types';

const FOCUSABLE_ELEMENTS_SELECTOR =
  'a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])';

export const WithTabbingTrap: React.FC<WithTabbingTrapProps> = ({
  children,
}) => {
  const wrapperRef = React.createRef<HTMLDivElement>();
  const bottomRef = React.createRef<HTMLDivElement>();
  const topRef = React.createRef<HTMLDivElement>();

  const attemptFocus = (element: HTMLElement) => {
    try {
      element.focus();
    } catch (e) {}
    return document.activeElement === element;
  };

  const handleFocusTrap = (edge: 'bottom' | 'top') => {
    let elements = Array.from(
      wrapperRef.current?.querySelectorAll(FOCUSABLE_ELEMENTS_SELECTOR) ?? [],
    );

    if (edge === 'top') {
      elements = elements.reverse();
    }

    for (const element of elements) {
      if (element === topRef.current || element === bottomRef.current) {
        continue;
      }
      if (attemptFocus(element as HTMLElement)) {
        return;
      }
    }
  };

  return (
    <div ref={wrapperRef}>
      <div
        tabIndex={0}
        ref={topRef}
        onFocus={() => handleFocusTrap('top')}
      ></div>
      {children}
      <div
        tabIndex={0}
        ref={bottomRef}
        onFocus={() => handleFocusTrap('bottom')}
      ></div>
    </div>
  );
};
